import { ClientAccountWillExecutor } from '@/shared/clients/client-account-will-executor';
import { ClientAccountWillGuardian } from '@/shared/clients/client-account-will-guardian';

export interface ClientAccountWill {
    id?: string | null;
    partnerPracticeReference: string | null;
    rightLegalReference: string | null;
    willTypeId: string | null;
    date: string | Date | null;
    hasGuardianAppointed: boolean;
    hasAttendanceNotes: boolean;
    hasFactFind: boolean;
    hasLetterOfWishes: boolean;
    hasJustToLetYouKnow: boolean;
    hasNoticeOfSeverance: boolean;
    hasOldWill: boolean;
    notes: string | null;
    isNewWill?: boolean;
    isHistorical?: boolean;
    guardians: Array<ClientAccountWillGuardian>;
    executors: Array<ClientAccountWillExecutor>;
    version?: number;
    createdDate?: string | Date | null;
    createdBy?: string | null;
}

export function createClientAccountWill(): ClientAccountWill {
    return {
        partnerPracticeReference: null,
        rightLegalReference: null,
        willTypeId: null,
        date: null,
        hasGuardianAppointed: false,
        hasAttendanceNotes: false,
        hasFactFind: false,
        hasLetterOfWishes: false,
        hasJustToLetYouKnow: false,
        hasNoticeOfSeverance: false,
        hasOldWill: false,
        notes: null,
        guardians: new Array<ClientAccountWillGuardian>(),
        executors: new Array<ClientAccountWillExecutor>(),
    };
}
